"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var useGlobalEvent_1 = __importDefault(require("../useGlobalEvent"));
/**
 * Returns a function that accepts a callback to be performed when the window scrolls.
 */
var useWindowScroll = function useWindowScroll() {
  return (0, useGlobalEvent_1["default"])('scroll');
};
exports["default"] = useWindowScroll;